// Live
export const UPDATE_RECOVERY_LIVE_PAGE = 'RECOVERY:UPDATE_RECOVERY_LIVE_PAGE';
export const RESET_RECOVERY_LIVE_PAGE = 'RECOVERY:RESET_RECOVERY_LIVE_PAGE';
export const ADD_VIEWING_CAMERA_SERIAL = 'RECOVERY:ADD_VIEWING_CAMERA_SERIAL';
export const REMOVE_VIEWING_CAMERA_SERIAL =
  'RECOVERY:REMOVE_VIEWING_CAMERA_SERIAL';

export const updateRecoveryLivePage = (payload) => ({
  type: UPDATE_RECOVERY_LIVE_PAGE,
  payload,
});

export const resetRecoveryLivePage = () => ({
  type: RESET_RECOVERY_LIVE_PAGE,
});

export const addViewingCameraSerial = (payload) => ({
  type: ADD_VIEWING_CAMERA_SERIAL,
  payload,
});

export const removeViewingCameraSerial = (payload) => ({
  type: REMOVE_VIEWING_CAMERA_SERIAL,
  payload,
});

// Camera
export const UPDATE_RECOVERY_CAMERA_PAGE =
  'RECOVERY:UPDATE_RECOVERY_CAMERA_PAGE';
export const UPDATE_RECOVERY_HISTORY_EVENT_OF_CAMERA_PAGE =
  'RECOVERY:UPDATE_RECOVERY_HISTORY_EVENT_OF_CAMERA_PAGE';
export const RESET_RECOVERY_CAMERA_PAGE = 'RECOVERY:RESET_RECOVERY_CAMERA_PAGE';
export const ADD_VIEWING_RECORD_ID = 'RECOVERY:ADD_VIEWING_RECORD_ID';
export const REMOVE_VIEWING_RECORD_ID = 'RECOVERY:REMOVE_VIEWING_RECORD_ID';

export const updateRecoveryCameraPage = (payload) => ({
  type: UPDATE_RECOVERY_CAMERA_PAGE,
  payload,
});

export const updateRecoveryHistoryEventOfCameraPage = (payload) => ({
  type: UPDATE_RECOVERY_HISTORY_EVENT_OF_CAMERA_PAGE,
  payload,
});

export const resetRecoveryCameraPage = () => ({
  type: RESET_RECOVERY_CAMERA_PAGE,
});

export const addViewingRecordId = (payload) => ({
  type: ADD_VIEWING_RECORD_ID,
  payload,
});

export const removeViewingRecordId = (payload) => ({
  type: REMOVE_VIEWING_RECORD_ID,
  payload,
});

// share
export const UPDATE_RECOVERY_SHARE_PAGE = 'RECOVERY:UPDATE_RECOVERY_SHARE_PAGE';
export const UPDATE_RECOVERY_CAMERA_TAB_OF_SHARE_PAGE =
  'RECOVERY:UPDATE_RECOVERY_CAMERA_TAB_OF_SHARE_PAGE';
export const UPDATE_RECOVERY_GROUP_CAMERA_TAB_OF_SHARE_PAGE =
  'RECOVERY:UPDATE_RECOVERY_GROUP_CAMERA_TAB_OF_SHARE_PAGE';
export const UPDATE_RECOVERY_MEMBER_TAB_OF_SHARE_PAGE =
  'RECOVERY:UPDATE_RECOVERY_MEMBER_TAB_OF_SHARE_PAGE';
export const RESET_RECOVERY_SHARE_PAGE = 'RECOVERY:RESET_RECOVERY_SHARE_PAGE';

export const updateRecoverySharePage = (payload) => ({
  type: UPDATE_RECOVERY_SHARE_PAGE,
  payload,
});

export const updateRecoveryCameraTabOfSharePage = (payload) => ({
  type: UPDATE_RECOVERY_CAMERA_TAB_OF_SHARE_PAGE,
  payload,
});

export const updateRecoveryGroupCameraTabOfSharePage = (payload) => ({
  type: UPDATE_RECOVERY_GROUP_CAMERA_TAB_OF_SHARE_PAGE,
  payload,
});
  
export const updateRecoveryMemberTabOfSharePage = (payload) => ({
  type: UPDATE_RECOVERY_MEMBER_TAB_OF_SHARE_PAGE,
  payload,
});

export const resetRecoverySharePage = () => ({
  type: RESET_RECOVERY_SHARE_PAGE,
});
